import { render, staticRenderFns } from "./MatchdayTakeover.vue?vue&type=template&id=e1a9785e&scoped=true"
import script from "./MatchdayTakeover.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeover.vue?vue&type=script&lang=js"
import style0 from "./MatchdayTakeover.vue?vue&type=style&index=0&id=e1a9785e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a9785e",
  null
  
)

export default component.exports